'use client';

import { useEffect, useRef, useState } from 'react';
import styles from './SubscribeForm.module.scss';
import modalStyles from '@/components/SendSubscribeModal/Modal.module.css';
import { Container } from '@/new/components';
import CloseSvg from '@/components/SendSubscribeModal/CloseSvg';
import * as ApiSite from '@/api/site';
import { toast } from 'sonner';


export function SubscribeForm() {
  const inputEmail = useRef<HTMLInputElement>(null);

  const [isValidEmail, setIsValidEmail] = useState<boolean | null>(null);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const yandexMetrikaId = Number(process.env.NEXT_PUBLIC_YANDEX_METRIKA);

  useEffect(() => {
    if (!isSuccessOpen) return;

    const previousOverflow = document.body.style.overflow;
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsSuccessOpen(false);
      }
    };

    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isSuccessOpen]);

  const handleEmailValidation = (email: string) => {
    email = email.trim();
    const re = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  };

  const submitSendCallback = async (event: { preventDefault: () => void }) => {
    event.preventDefault();

    const email = inputEmail.current?.value || '';

    if (!email.length || !handleEmailValidation(email)) {
      setIsValidEmail(false);
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const yclid = urlParams.get('yclid');

    const jsonData = {
      user_email: email,
      yclid,
    };

    setIsSubmitting(true);

    try {
      await ApiSite.subscribe(jsonData);

      if (typeof window !== 'undefined' && window.ym && !isNaN(yandexMetrikaId)) {
        window.ym(yandexMetrikaId, 'reachGoal', 'callback_request');
      }

      toast.success('Вы подписались на новости!', {
        duration: 5000,
        position: 'top-center',
      });

      if (inputEmail.current) inputEmail.current.value = '';
      setIsValidEmail(null);
      setIsSuccessOpen(true);
    } catch (error) {
      toast.error('Произошла ошибка при оформлении подписки. Пожалуйста, попробуйте позже.', {
        duration: 5000,
        position: 'top-center',
      });
      console.error('Subscribe request error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container>
      <div className={styles.cont}>
        <div>
          <div className={styles.img}>
            {/*<img src={'/images/subscribe_1.png'} alt={''} width={380} height={380} loading={'lazy'} />*/}
            {/*<Image src={'/images/subscribe_1.png'} alt={''} width={420} height={420} loading={'lazy'} />*/}
            <img src={'/images/subscribe_1.png'} alt={''} width={420} height={420} loading={'lazy'} />
          </div>
        </div>

        <form className={styles.form} onSubmit={submitSendCallback}>
          <div>
            <h2>Подпишитесь на наши новости</h2>
            <p>
              Будьте в курсе всех актуальных тендеров и изменений в 44-ФЗ и 223-ФЗ — только важная
              информация без спама
            </p>
          </div>

          <div className={styles.dataChunk}>
            <label>Ваша электронная почта</label>
            <input placeholder={'Электронная почта'} ref={inputEmail} type="text" />
            {isValidEmail === false && (
              <div className={styles.error}>Укажите корректно электронную почту</div>
            )}
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Отправка...' : 'Подписаться'}
              </button>
              <div className={styles.privacy}>
                <p>
                  Нажимая на кнопку «Подписаться» вы соглашаетесь c{' '}
                  <a href={'/privacy'} target={'_blank'} rel="noopener noreferrer">
                    политикой конфиденциальности
                  </a>
                  , а так же даёте{' '}
                  <a href={'/newsletter'} target={'_blank'} rel="noopener noreferrer">
                    согласие на информационную и рекламную рассылку
                  </a>
                </p>
              </div>
            </div>
          </div>
        </form>

        {/*
          Старый поток через SendSubscribeModal с reCAPTCHA временно отключен.
          Подписка отправляется напрямую в submitSendCallback, после успешного ответа открывается только окно успеха.
        */}
        {isSuccessOpen && (
          <div
            className={modalStyles.overlay}
            onMouseDown={(event) => {
              if (event.target === event.currentTarget) {
                setIsSuccessOpen(false);
              }
            }}
          >
            <div className={modalStyles.modalWindow}>
              <div className={modalStyles.closeButton}>
                <button
                  className={modalStyles.close}
                  onClick={() => setIsSuccessOpen(false)}
                >
                  <CloseSvg />
                </button>
              </div>

              <h2 className={modalStyles.title}>Запрос отправлен</h2>
              <p
                className={modalStyles.subtitle}
                style={{
                  fontSize: 17,
                  textAlign: 'center',
                }}
              >
                Отлично! Теперь вы в курсе всего самого важного в мире госзакупок.
              </p>

              <button
                style={{
                  marginTop: 16,
                  width: '100%',
                  padding: 16,
                  fontSize: 22,
                  backgroundColor: 'rgb(24, 29, 34)',
                  color: 'white',
                  borderRadius: 12,
                }}
                onClick={() => setIsSuccessOpen(false)}
                autoFocus
              >
                Хорошо
              </button>
            </div>
          </div>
        )}
      </div>
    </Container>
  );
}
